import React from 'react';

function MultiLine({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...otherProps}
    >
      <rect x="0.65" y="4.65" width="22.7" height="14.7" rx="1.35" />
      <path d="M3 7C3.5 7 4 7.6 4 8C4 8.4 4 10.1667 4 11C4 11.3333 3.8 12 3 12" />
      <path d="M5 7C4.5 7 4 7.5 4 8M5 12C4.66667 12 4 11.8 4 11" />
    </svg>
  );
}

export default MultiLine;
